import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TopNavComponent } from '../shared/top-nav/top-nav.component';

export interface PerformanceReviewData {
  performanceReview: string;
  skill: string;
  skillComments: string;
  developmentActions: string;
  employeeAspirations: string;
  employeeContribution: string;
  talents: string;
  retentionRisk: number;
}

@Component({
  selector: 'app-performance-review',
  standalone: true,
  imports: [CommonModule, FormsModule, TopNavComponent],
  templateUrl: './performance-review.component.html',
  styleUrl: './performance-review.component.scss',
})
export class PerformanceReviewComponent {
  employeeId: string = '';
  employeeName: string = 'Name';

  formData: PerformanceReviewData = {
    performanceReview: '',
    skill: '',
    skillComments: '',
    developmentActions: '',
    employeeAspirations: '',
    employeeContribution: '',
    talents: '',
    retentionRisk: 1,
  };

  retentionRiskOptions = [
    { value: 1, label: '1-Lowest' },
    { value: 2, label: '2-Low' },
    { value: 3, label: '3-Medium' },
    { value: 4, label: '4-High' },
    { value: 5, label: '5-Highest' },
  ];

  constructor(private router: Router, private route: ActivatedRoute) {
    // Get employee ID from route params
    this.route.params.subscribe((params) => {
      this.employeeId = params['id'] || '';
    });
  }

  onCancel() {
    // Navigate back to employee detail
    this.router.navigate(['/employee', this.employeeId]);
  }

  onSubmit() {
    console.log('Performance Review Submitted:', this.formData);

    // Here you would typically send the data to a service
    alert('Performance review submitted successfully!');

    // Navigate back to employee detail
    this.router.navigate(['/employee', this.employeeId]);
  }

  isFormValid(): boolean {
    return (
      this.formData.performanceReview.trim() !== '' &&
      this.formData.skill.trim() !== '' &&
      this.formData.skillComments.trim() !== '' &&
      this.formData.developmentActions.trim() !== '' &&
      this.formData.employeeAspirations.trim() !== '' &&
      this.formData.employeeContribution.trim() !== '' &&
      this.formData.talents.trim() !== ''
    );
  }
}
